module.exports = __webpack_public_path__ + "img/home_auth1.8f678c92.png";